import $ from "jquery";
import * as Dust from "dustjs-linkedin";
import * as DustHelpers from "dustjs-helpers";
import Swiper from "swiper/dist/js/swiper";
import compiler from "./utilities/dust-compiler";

window.$ = $;
window.jQuery = $;
window.Dust = Dust;
window.DustHelpers = DustHelpers;
Dust.compile = compiler.compile;
window.dust = Dust;
window.Swiper = Swiper;



// WEBPACK FOOTER //
// ./src/common/default_libs.js